import React, { useState, useEffect, useRef } from "react";
import Button from "../Button";
import styles from "./ErrorDialog.css";

const ErrorDialog = ({ error, dispatch }) => {
    const ref = useRef();

    useEffect(() => {
        if (open && !ref.current.open) {
            ref.current.showModal();
        }
    }, []);

    return (
        <dialog ref={ref} className={styles.Dialog}>
            <div className={styles.DialogContainer}>
                <header className={styles.Header}>
                    <h1 className={styles.Title}>
                        Er gab ein Problem bei der Anmeldung.
                    </h1>

                    {error.messages.map((message) => (
                        <p>{message}</p>
                    ))}
                    <p>
                        <Button
                            onClick={() => dispatch({ type: "CLEAR_ERROR" })}
                        >
                            Schließen
                        </Button>
                    </p>
                </header>
            </div>
        </dialog>
    );
};

export default ErrorDialog;
